import React from "react";

// import './assets/css/style.css';
// import './assets/vendor/aos/aos.css';
// import './assets/vendor/bootstrap/css/bootstrap.min.css';
// import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
// import './assets/vendor/boxicons/css/boxicons.min.css';
// import './assets/vendor/glightbox/css/glightbox.min.css';
// import './assets/vendor/swiper/swiper-bundle.min.css';

const Contact = () =>{
    return(
<section id="contact" class="contact section-bg">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Contact Us</h2>
        </div>

        <div class="row">

          <div class="col-lg-5 d-flex align-items-stretch" data-aos="">
            <div class="info">
              <div class="address">
                <i class="bi bi-geo-alt"></i>
                <h3>SpireWeb Technologies</h3>
              <p>
               <strong>Registered Corporate Office :</strong><br/><br/>  A/P- Plot No 47, Trimurti Colony, <br/>
               Nave Pargaon Tal- Hatkanangle, Dist- Kolhapur 416 113.<br/><br/>
               
               <strong>Other Office Locations :&nbsp;</strong>
                Pune | Warananagar | Peth Vadgaon  <br/><br/>
                
              </p>
              </div>

              <div class="email">
                <i class="bi bi-envelope"></i>
                <h4>Email:</h4>
                <p><a href="mailto:info@spirewebtechnologies.com">info@spirewebtechnologies.com</a></p>
              </div>

              <div class="phone">
                <i class="bi bi-phone"></i>
                <h4>Call:</h4>
                <p><a href="tel:+918806122020">+91 880 612 2020</a></p>
              </div>

              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.346491963401!2d74.2340814825017!3d16.858745876431055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc107c290344d79%3A0x8d8057a4b3f9dc11!2sSpireWeb%20Technologies!5e0!3m2!1sen!2sin!4v1687251344039!5m2!1sen!2sin" width="100%" height="250px"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

          </div>
          <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="">
            <form action="forms/contact.php" method="post" role="form" class="php-email-form">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="name">Your Name</label>
                  <input type="text" name="name" class="form-control" id="name" required/>
                </div>
                <div class="form-group col-md-6 mt-3 mt-md-0">
                  <label for="name">Your Email</label>
                  <input type="email" class="form-control" name="email" id="email" required/>
                </div>
              </div>
              <div class="form-group mt-3">
                <label for="name">Subject</label>
                <input type="text" class="form-control" name="subject" id="subject" required/>
              </div>
              <div class="form-group mt-3">
                <label for="name">Message</label>
                <textarea class="form-control" name="message" rows="10" required></textarea>
              </div>
              <div class="my-3">
                <div class="loading">Loading</div>
                <div class="error-message"></div>
                <div class="sent-message">Your message has been sent. Thank you!</div>
              </div>
              <div class="text-center"><button type="submit">Send Message</button></div>
            </form>
          </div>

        </div>

      </div>
          
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<ins class="adsbygoogle"
    //  style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-1937777226188556"
     data-ad-slot="2825915952"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script>
        
    </section>
    );
}



export default Contact;